import { OverflowText } from "designSystem/index";
import dndCss from "../styles/dnd.module.css";
import React from "react";

/** placeholder to showcase a drop zone that may not be obvious */
export const DropPlaceholder = (): JSX.Element => (
	<div className={dndCss.dropPlaceholder}>
		<OverflowText res="DragAndDropAttributes" />
	</div>
);
